import { useDispatch, useSelector } from "react-redux";

import { StoreState } from "../../store";
import { Locale, LocalCode, SET_LOCALE, SET_LOCAL_CODE } from "../../store/i18n/types";
import { resolveLocale, setSessionLanguage } from ".";


/*
Single entry point to change the session language, shared by the auth screens
and the header menu.

On the auth screens there is no user loaded yet, so only the local code (which
drives the static auth translations) is updated. Once logged in, the resolved
locale is dispatched too and UserConfig reacts to it by re-fetching the CMS
content, retargeting moment and updating the document language.
*/
export function useSelectLanguage() {

    let dispatch = useDispatch();

    let accountLocale = useSelector<StoreState, Locale | undefined>(
        state => state.user.info?.locale.code
    );

    return (code: LocalCode) => {

        setSessionLanguage(code);

        dispatch({
            type: SET_LOCAL_CODE,
            payload: code
        });

        if (accountLocale !== undefined) {
            dispatch({
                type: SET_LOCALE,
                payload: resolveLocale(code, accountLocale)
            });
        }
    };
}

export default useSelectLanguage;
